import React from "react";

import {
  Alert,
  Box,
  Button,
  Drawer,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";

import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";

import ChatComponent from "pages/appointmentByAdmin/ChatComponent/ChatComponent";

import ConsultationDocuments from "./ConsultationDocuments";
import CommentsSection from "pages/appointmentByAdmin/ChatComponent/components/CommentsSection";

const ConsultationSidePanel = ({
  open,
  activeTab,
  onTabChange,
  onClose,

  appointmentId,

  attachments,
  comments,

  documentsLoading,
  documentsError,
  onRefreshDocuments,
}) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: {
            xs: "92vw",
            sm: 420,
          },
          maxWidth: "100%",
        },
      }}
    >
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            px: 2,
            py: 1.5,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Typography variant="h6">Consultation Tools</Typography>

          <IconButton onClick={onClose} aria-label="Close consultation tools">
            <CloseOutlinedIcon />
          </IconButton>
        </Stack>

        <Tabs
          value={activeTab}
          onChange={(event, nextTab) => onTabChange(nextTab)}
          variant="fullWidth"
        >
          <Tab value="chat" label="Chat" />

          <Tab value="documents" label="Reports" />
        </Tabs>

        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            p: 2,
          }}
        >
          {activeTab === "chat" && (
            <Stack spacing={2}>
              {/* <Box>
                <Typography variant="subtitle1" fontWeight={600}>
                  Consultation Messages
                </Typography>

                <CommentsSection comments={comments} />
              </Box> */}

              <Box
                sx={{
                  borderTop: "1px solid",
                  borderColor: "divider",
                  pt: 2,
                }}
              >
                <ChatComponent aptId={appointmentId} />
              </Box>
            </Stack>
          )}

          {activeTab === "documents" && (
            <Stack spacing={2}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography variant="subtitle1" fontWeight={600}>
                  Reports & Documents
                </Typography>

                <Button
                  size="small"
                  startIcon={<RefreshOutlinedIcon />}
                  disabled={documentsLoading}
                  onClick={onRefreshDocuments}
                >
                  {documentsLoading ? "Refreshing..." : "Refresh"}
                </Button>
              </Stack>

              <Typography variant="body2" sx={{ color: "gray" }}>
                Uploaded reports
              </Typography>

              {documentsError && (
                <Alert severity="error">{documentsError}</Alert>
              )}

              <ConsultationDocuments attachments={attachments} />
            </Stack>
          )}
        </Box>
      </Box>
    </Drawer>
  );
};

export default ConsultationSidePanel;
